import humanparser from 'humanparser';
import api from '../callApi';
import requestBraintreePayment from './braintree';
import requestPandaPayment from './pandaPay';

const createPaymentErrorMessage = "Couldn't create payment, try again later";

const getErrorMessage = errorList =>
    errorList && errorList.length ? errorList[0] : createPaymentErrorMessage;

const initiateDonation = (apiRequestData, data) => {
    const payment = {
        paymentMethod: data.paymentMethod,
        amount: data.amount
    };

    return api
        .post('Widget/InitiateDonationAsync', {
            ...apiRequestData,
            ...payment
        })
        .then(response => {
            if (
                (response.clientToken == null && data.paymentMethod === 'Braintree') ||
                response.trackingId == null ||
                (response.errorList != null && response.errorList.length)
            ) {
                return Promise.reject(getErrorMessage(response.errorList));
            }

            return { ...data, ...response };
        });
};

const getPaymentNonce = (paymentMethod, data) => {
    if (paymentMethod === 'Braintree') {
        return requestBraintreePayment(data);
    }
    if (paymentMethod === 'PandaPay') {
        return requestPandaPayment(data);
    }

    Promise.reject(
        'There was an error with the payment gateway while initiating your donation! Please try again!'
    );
};

const createCompleteDonationRequest = data => {
    const name = humanparser.parseName(data.fullName);
    return {
        user: {
            firstName: name.middleName
                ? name.firstName + ' ' + name.middleName
                : name.firstName,
            lastName: name.lastName,
            email: data.email,
            address: {
                zipCode: data.postalCode
            }
        },
        notifyResult: data.getUpdates,
        trackingId: data.trackingId,
        paymentNonce: data.nonce,
        amount: data.amount,
        actionCompletedTime: data.actionCompleteTime
    };
};

const completeDonation = (apiRequestData, data) => {
    const request = {
        ...createCompleteDonationRequest(data),
        ...apiRequestData
    };

    return api.post('Widget/CompleteDonationAsync', request).then(response => {
        if (
            response.status === 'Rejected' ||
            response.status === 'Error' ||
            response.status === 'ValidationFailed'
        ) {
            return Promise.reject(getErrorMessage(response.errorList));
        }

        return response;
    });
};

const submitDonation = (apiRequestData, request) => {
    return initiateDonation(apiRequestData, request)
        .then(data => getPaymentNonce(request.paymentMethod, data))
        .then(data => completeDonation(apiRequestData, data))
        .catch(() => Promise.reject(createPaymentErrorMessage));
};

export default submitDonation;



// WEBPACK FOOTER //
// ./src/utils/donation/donationApi.js